export default __webpack_public_path__ + "static/media/Gauntlets of Baleful Blood.53f328ed.jpg";